import React, { useState } from 'react';
import { Dropdown, Modal, message, Button } from 'antd';
import { EditOutlined, DeleteOutlined, SettingOutlined, WifiOutlined, ExperimentOutlined, AimOutlined, LockOutlined } from '@ant-design/icons';
import IrrigationParam from './irrigationParams/IrrigationParam';
import PointsParams from './PointsParams';
import HardwareParam from './HardwareParam';
import SupportedAnalysis from './SupportedAnalysis';
import ExploitationEditPage from './ExploitationEditPage ';
import ExpPassword from './ExpPassword';




const ActionsMenu = ({ record, deleteExploitation, fetchData, product }) => {

  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedEditOption, setSelectedEditOption] = useState(null);

  const handleDelete = () => {
    Modal.confirm({
      title: 'Êtes-vous sûr de vouloir supprimer cette exploitation ?',
      content: 'Cette action ne peut pas être annulée. Cela supprimera définitivement l\'exploitation et toutes les données associées.',
      okText: 'Supprimer',
      okType: 'danger',
      cancelText: 'Annuler',
      onOk() {
        deleteExploitation(record.exploitation_id)
          .then(() => {
            message.success('Exploitation supprimée avec succès');
            fetchData();
          })
          .catch((error) => {
            console.error('Erreur lors de la suppression de l\'exploitation:', error);
            message.error('Échec de la suppression de l\'exploitation');
          });
      },
    });
  };

  const handleEditMenuClick = ({ key }) => {
    setSelectedEditOption(key);
    setIsEditModalVisible(true);
  };

  const editItems = [
    {
      key: 'exploitation',
      label: 'Exploitation',
      icon: <SettingOutlined />
    },
    {
      key: 'irrigation',
      label: 'Paramètres d\'irrigation',
      icon: <ExperimentOutlined />
    },
    {
      key: 'points',
      label: 'Paramètres des points',
      icon: <AimOutlined />
    },
    {
      key: 'hardware',
      label: 'Hardware',
      icon: <WifiOutlined />
    },
    {
      key: 'analysis',
      label: 'Analyses',
      icon: <ExperimentOutlined />
    }
  ];

  // Render edit dropdown options based on the product is_irrigation and is_soil
  if (product) {
    if (!product.is_irrigation) {
      editItems.splice(1, 1);
    }
    if (!product.is_soil) {
      editItems.splice(2, 1);
    }
  }

  // if record.manager exists, add password option
  if (record.manager) {
    editItems.push({
        key: 'password',
        label: 'Modifier le mot de passe ou l\'email',
        icon: <LockOutlined />
      }
    );
  }

  const renderEditContent = () => {
    switch (selectedEditOption) {
      case 'exploitation':
        return <ExploitationEditPage exploitationId={record.exploitation_id} />;
      case 'irrigation':
        return <IrrigationParam exploitationId={record.exploitation_id} product={product} />;
      case 'points':
        return <PointsParams exploitationId={record.exploitation_id} />;
      case 'hardware':
        return <HardwareParam exploitationId={record.exploitation_id} />;
      case 'analysis':
        return <SupportedAnalysis exploitationId={record.exploitation_id} />;
      case 'password':
        return <ExpPassword exploitationId={record.exploitation_id} onClose={() => setIsEditModalVisible(false)} />;
      default:
        return <div>Sélectionnez une option d'édition</div>;
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <Dropdown
        menu={{
          items: editItems,
          onClick: handleEditMenuClick
        }}
      >
        <EditOutlined className="cursor-pointer text-blue-500 text-2xl" />
      </Dropdown>
      <DeleteOutlined className="cursor-pointer text-red-500 text-2xl" onClick={handleDelete} />

      <Modal
        open={isEditModalVisible}
        onCancel={() => {
          fetchData();
          setIsEditModalVisible(false)
        }}
        footer={null}
        width="auto"
        className="responsive-modal"
        style={{
          top: '5vh',
        }}
        classNames={{
          mask: 'bg-black/60 backdrop-blur-sm'
        }}
        centered
      >
        <div className="w-[95vw] sm:w-[85vw] xl:w-[80vw] 2xl:w-[1400px] mx-auto">
          <div className="bg-white rounded-lg pt-8">
            <div className="p-4 sm:p-6 lg:p-8 max-h-[90vh] w-full overflow-y-auto">
              {renderEditContent()}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ActionsMenu;